import React from "react";
import { Spinner } from "reactstrap";

import { AUTOPILOT_COLORS } from "../../../../components/autopilot/styles";
import ShellCard from "../../../../components/ShellCard";
import { PageHeroRefreshButton } from "../../../../components/PageHero";
import StatusBadge from "./StatusBadge";

// Card "Últimos envios" (PO1-2719): mesmo componente nos dois canais. O
// backend já filtra pelo canal, então este card nunca mistura os dois lados.
export default function UltimosEnviosCard({ envios, loading, onAtualizar }) {
  return (
    <ShellCard
      title="Últimos envios"
      style={{ marginTop: 0 }}
      action={<PageHeroRefreshButton onClick={onAtualizar} loading={loading} />}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: "1rem" }}>
          <Spinner color="info" size="sm" />
        </div>
      ) : !envios || envios.length === 0 ? (
        <p style={{ color: AUTOPILOT_COLORS.muted, fontSize: "0.8rem", marginBottom: 0 }}>
          Nenhum envio recente.
        </p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {envios.map((envio) => (
            <div
              key={envio.id}
              style={{
                border: `1px solid ${AUTOPILOT_COLORS.border}`,
                borderRadius: 10,
                padding: "10px 12px",
              }}
            >
              <div
                style={{
                  color: AUTOPILOT_COLORS.muted,
                  fontSize: "0.72rem",
                  marginBottom: 6,
                }}
              >
                {new Date(envio.dataHora).toLocaleString("pt-BR")}
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                {(envio.arquivos || []).map((arquivo) => (
                  <div
                    key={arquivo.nome}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <span
                      style={{
                        color: AUTOPILOT_COLORS.text,
                        fontSize: "0.78rem",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                      title={arquivo.motivo || undefined}
                    >
                      {arquivo.nome}
                    </span>
                    <StatusBadge status={arquivo.status} />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </ShellCard>
  );
}
